<template>
  <div class="my-page page-wrap b1">
    <div autoplay="autoplay" class="page-container">
      <Player v-if="!isShowCover" class="video b1" @onStartPlay="onStartPlay" />
      <VideoMask v-if="isMaskShowFix" :style="[videoHeightStyle]" />
      <div :style="videoHeightStyle" />
      <div class="cover b1" v-if="isShowCover" :style="[videoHeightStyle]">
        <img
          class="imgDefault"
          :src="
            resp && resp.detail && resp.detail.detail.coverImagUrl
              ? resp.detail.detail.coverImagUrl
              : ''
          "
          :style="[videoHeightStyle]"
          alt=""
        />
        <img
          src="../../static/ic_play_grey.png"
          class="btnPlay"
          @click="playCourseVideo(resp.detail.courses.page.list[0])"
          alt=""
        />
      </div>

      <template v-if="getTodayTip">
        <div class="s8 t1 marginL30 jrgxTitle">今日更新</div>
        <div
          class="videoToday"
          @click="playCourseVideo(getTodayTip)"
          :class="getTodayTip.videoIdenftity === currentVideo ? 'c5' : 't1'"
        >
          【{{ dayjs(getTodayTip.updateTime).format('MM-DD') || '' }}】
          {{ getTodayTip.title || '' }}
          <img src="../../static/ic_play_grey.png" />
        </div>
      </template>

      <van-sticky :offset-top="navOffest">
        <NavItem
          :items="navItems"
          @onItemClick="onItemClick"
          class="sepBottom b1"
        />
      </van-sticky>
      <swiper
        :options="swiperOption"
        class="swiper-img"
        ref="mySwiper"
        @slideChange="slideChange"
      >
        <swiper-slide>
          <CourseVideoDetail
            @updateSwiper="updateSwiper"
            @playCourseVideo="playCourseVideo"
          />
        </swiper-slide>
        <swiper-slide>
          <Comment
            @updateSwiper="updateSwiper"
            videoType="shrink"
            :showPupInput="!showCommentDetail && !!currentIndex"
            :commentsInfo="commentsInfo"
            :hasPermission="hasPermission"
            @onReplyEvent="onReplyEvent"
            @onShowAllEvent="onShowAllEvent"
          />
        </swiper-slide>
      </swiper>

      <PayBanner
        :subscribeStatus="
          resp &&
            resp.detail &&
            resp.detail.detail &&
            resp.detail.detail.subscribeStatus
        "
        v-if="!(hasPermission && !!currentIndex)"
        videoType="shrink"
      />
    </div>

    <div
      class="comment-container b1"
      :style="[commentStyle]"
      v-if="showCommentDetail"
      @touchmove.stop
    >
      <CommentDetail
        :commentsInfo="commentsInfo"
        :comment="currComment"
        :isPermission="hasPermission"
        @onCloseEvent="onCloseEvent"
        :isShowAll="isShowAll"
      />
    </div>
  </div>
</template>

<script>
import http from '../../api/http'
import NavItem from '../comm/NavItem'
import CourseVideoDetail from './CourseVideoDetail'
import PayBanner from '../video/PayBanner'
import CommentDetail from '@/views/CourseDetail/comment/CommentDetail'
import { mapActions, mapState } from 'vuex'
import dayjs from 'dayjs'
import Player from '@/views/video/Player'
import util from '@/util/util'
import { requestappInfo, getAppInfo } from '@/api/appInfo'
import { checkPermission } from '@/api/permission'
import Comment from '@/views/comment/Comment'
import permissionUtil from '@/util/PermissionUtil'
import VideoMask from '@/views/video/VideoMask'
import { Sticky } from 'vant'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'
export default {
  name: 'CourseDetail',
  components: {
    VideoMask,
    Player,
    PayBanner,
    Comment,
    CourseVideoDetail,
    NavItem,
    CommentDetail,
    [Sticky.name]: Sticky,
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      productId: '',
      isShowCover: true,
      currComment: {},
      currentIndex: 0,
      isMaskShow: false,
      isShowAll: false,
      navItems: [
        {
          name: '详情',
          isSelect: true
        },
        {
          name: '评论',
          isSelect: false
        }
      ],
      swiperOption: {
        autoplay: false,
        autoHeight: true,
        observer: true,
        observeParents: true
      }
    }
  },
  mounted() {
    const appId = this.$route.query.appId
    const wxAppId = this.$route.query.wxAppId
    if (appId) {
      localStorage.setItem('currentAppId', appId)
      localStorage.setItem('wxAppId', wxAppId)
    }
    const param = {
      setId: this.$route.params.id
    }
    this.requestDetail(param)
    requestappInfo()

    window.onResume = () => {
      requestappInfo()
      let _this = this
      if (!this.hasPermission) {
        setTimeout(
          () =>
            checkPermission(this.productId, function() {
              _this.requestDetail(param)
            }),
          5000
        )
      }
    }

    window.onscroll = this.updateMaskPosition
    let lastOrientationChangeTime
    window.addEventListener(
      'onorientationchange' in window ? 'orientationchange' : 'resize',
      () => {
        setTimeout(() => {
          this.updateMaskPosition()
        }, 500)
        lastOrientationChangeTime = new Date().getTime()
      },
      false
    )
    const innerH = window.innerHeight
    window.addEventListener('resize', () => {
      setTimeout(() => {
        if (new Date().getTime() - lastOrientationChangeTime < 300) return
        if (window.orientation === 180 || window.orientation === 0) {
          console.log('scroll', window.innerWidth, window.innerHeight)
          window.scrollBy(0, window.innerHeight < innerH ? 300 : -300)
        }
      }, 100)
    })
  },
  computed: {
    ...mapState('video', ['resp', 'currentVideo']),
    hasPermission() {
      return permissionUtil.getRightByProductId(this.productId)
    },
    navOffest() {
      return util.getVideoHeight()
    },
    commentsInfo() {
      if (!this.resp.detail) {
        return null
      }
      return this.resp.detail.commentsInfo
    },

    showCommentDetail() {
      return Object.keys(this.currComment).length > 0
    },
    isMaskShowFix() {
      return this.isMaskShow
    },
    getTodayTip() {
      if (!this.resp.detail) {
        return null
      }
      return this.resp.detail.toDayCourse
    },

    videoHeightStyle() {
      return {
        height: util.getVideoHeight() + 'px'
      }
    },

    commentStyle() {
      const top = util.getVideoHeight() + 'px'
      const commentHeight = window.screen.height - util.getVideoHeight() + 'px'
      return {
        top: top,
        height: commentHeight
      }
    },
    swiper() {
      return this.$refs.mySwiper.$swiper
    }
  },

  watch: {
    showCommentDetail(val) {
      this.bodyElm = this.bodyElm || document.body
      val
        ? (this.bodyElm.style.overflow = 'hidden')
        : (this.bodyElm.style.overflow = 'auto')
    },
    resp(val) {
      this.productId = val.detail.detail.productId
      this.$set(
        this.navItems[1],
        'title',
        val.detail.commentsInfo.commentsCount
      )
      if (permissionUtil.getRightByProductId(this.productId)) {
        this.navItems[1].isSelect = false
        this.navItems[0].isSelect = true
        this.currentIndex = 0
        this.playCourseVideo(val.detail.courses.page.list[0])
      }
      this.tryShowShare()
    }
  },

  methods: {
    ...mapActions('video', ['requestDetail', 'requestVideo']),

    dayjs,
    onItemClick(index) {
      this.currentIndex = index
      this.swiper.slideTo(index)
    },
    updateSwiper() {
      this.swiper.update()
    },
    slideChange() {
      this.currentIndex = this.swiper.activeIndex
      this.navItems[this.currentIndex].isSelect = true
      this.navItems[this.currentIndex ^ 1].isSelect = false
    },

    onReplyEvent(item) {
      console.log('=======onReplyEvent', item)
      this.currComment = item
    },
    onShowAllEvent(val) {
      this.isShowAll = val
    },

    onCloseEvent() {
      this.currComment = ''
    },

    playCourseVideo(course) {
      this.isShowCover = false
      this.requestVideo({
        videoIdentity: course.videoIdentity
      })
    },
    onStartPlay() {
      this.isMaskShow = true
      this.updateMaskPosition()
    },
    updateMaskPosition() {
      let mask = document.querySelector('video')
      let rect = mask.getBoundingClientRect()
      if (window.goods) {
        if (window.orientation === 180 || window.orientation === 0) {
          let devicePixelRatio = window.devicePixelRatio

          window.goods.updateVideoMask(
            this.isMaskShow,
            rect.x * devicePixelRatio,
            rect.y * devicePixelRatio,
            rect.width * devicePixelRatio,
            rect.height * devicePixelRatio
          )
        } else if (window.orientation === 90 || window.orientation === -90) {
          //横屏交给native全屏
          window.goods.updateVideoMask(this.isMaskShow, 0, 0, 0, 0)
        }
      }
    },

    tryShowShare() {
      if (getAppInfo().appVersion >= '3.1.0') {
        http
          .post('Course/api/GetShare', { setId: this.resp.detail.detail.setId })
          .then(response => {
            window.goods.showShare(
              JSON.stringify({
                isShow: true,
                title: response.detail.title,
                content: response.detail.content,
                url: response.detail.url
              })
            )
          })
      }
    },

    goIM() {
      util.go('ycstock://onlineservice?code=course')
    }
  }
}
</script>

<style scoped>
.video {
  position: fixed;
  top: 0;
  z-index: 999;
  width: 100%;
}

.statusBg {
  width: 100%;
  position: fixed;
  top: 0;
  height: 100px;
  z-index: 1;
}
.my-page {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  padding-bottom: 190px;
}
.page-container {
  position: relative;
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 190px;
}

.marginL30 {
  margin-left: 30px;
}

.jrgxTitle {
  margin-top: 40px;
}

.videoToday {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  margin: 26px 30px 39px;
  line-height: 106px;
  height: 106px;
  padding-left: 49px;
  background: #f3f3f3;
  position: relative;
  align-items: center;
}

.videoToday img {
  height: 52px;
  width: 52px;
  margin-right: 39px;
}

.sep20 {
  height: 20px;
  width: 100%;
}
.comment-container {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
}

.cover {
  top: 0;
  position: fixed;
  z-index: 10002;
  width: 100%;
  -webkit-overflow-scrolling: touch;
}

.btnPlay {
  width: 100px;
  height: 100px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50px, -50px);
}

.imgDefault {
  display: inline-block;
  background-color: #fff;
  background-image: url('../../static/img_load_default_l.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position-x: 50%;
  width: 100%;
  object-fit: 'cover';
}

.onlineservice {
  position: fixed;
  right: 30px;
  width: 100px;
  height: 100px;
}
</style>
